<template>
  <div class="home pad">
    <h1 class="title is-6">{{ time }}</h1>
    <div class="columns is-multiline">
      <div class="column is-4" v-for="item in menuItems" :key="item.name">
        <button @click="menuItemClicked(item)" class="button is-large is-outlined is-default is-fullwidth">
          {{ item.name }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'home',
  data () {
    return {
      time: ''
    }
  },
  computed: {
    menuItems () { return this.$store.getters.menuItems.filter(item => item.home !== false) }
  },
  created () {
    this.updateTime()
    setInterval(this.updateTime, 60000)
  },
  methods: {
    menuItemClicked (item) {
      this.$router.push(item.to)
    },
    updateTime () {
      this.time = this.$moment().format('dddd wo MMMM YYYY h:mma')
    }
  }
}
</script>

<style>
.home .columns {
  padding-top: 5%;
  margin: 0px auto;
  max-width: 1024px;;
}
.home button.button {
  height: 100px;
  background-color: #efefef;
}
</style>
